import { useMutation } from "@tanstack/react-query";
import { SearchState } from "Pages/Search/index.types";
import { OnDemandDatasets } from "Utils";
import { AxiosResponse } from "axios";
import { HttpClient } from "config/httpClient";
import { ApiResponse } from "types/OnDemand.types";

export const getDebitosFederaisResults = ({ searchParams }: SearchState) => {
  const response = HttpClient().post<ApiResponse>("empresas", {
    Datasets: OnDemandDatasets.GovernmentDebtors,
    q: `doc\{${searchParams.doc}\}`,
  });

  return response;
};

export const useSearchDebitosFederais = (
  onSuccess: (
    data: AxiosResponse<ApiResponse>,
    variables: SearchState,
    context: unknown,
  ) => void,
) =>
  useMutation({
    mutationFn: getDebitosFederaisResults,
    onSuccess,
    retry: 1,
  });
